// eslint-disable-next-line no-secrets/no-secrets
export const GoogleMapReactURLKeys = "AIzaSyBqbNQFxu7YQ7m_famY90CI-wLU7f2UxVk";
